module.exports = __webpack_public_path__ + "images/help/guide_video_file-29509c498c5af6780e0d33a5169cbf7d.png";